import {ReactComponent as Logo} from '../assets/Wingstop_Logo_CMYK_White.svg';

export const Title = () => (
  <div className="title">
    <h1>Does Your Team Have Bold Flavor?</h1>
    <Logo className="titleLogo" />
    <p>
    Wingstop knows bold flavor and the teams in this year’s Women’s College Basketball Tournament have insanely bold skills. FanSided and Wingstop teamed up to match your favorite team with your favorite flavor. See where your team’s skills fall on the Wingstop heat scale!
    </p>
  </div>
);
